@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.date-picker-link-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: @fulfillment-planner--ship-date--hover--text-color;

    svg {
      fill: @fulfillment-planner--ship-date--hover--fill-color;
    }
  }
}
